export default "__VITE_ASSET__DJXGCJRt__"